import { render, staticRenderFns } from "./ZZLFile.vue?vue&type=template&id=521e44b3"
import script from "./ZZLFile.vue?vue&type=script&lang=js"
export * from "./ZZLFile.vue?vue&type=script&lang=js"
import style0 from "./ZZLFile.vue?vue&type=style&index=0&id=521e44b3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports